export const uploadSubRoute = {
  presignedUrl: "presignedUrl",
  /** Authenticated proxy: fetch remote document URL and stream as attachment. */
  downloadByUrl: "downloadByUrl",
} as const;

export interface UploadRoutes {
  sub: typeof uploadSubRoute.presignedUrl | typeof uploadSubRoute.downloadByUrl;
  method?: "Post" | "Get";
}
